import { getCountries, register, clerkSearchPlayer, clerkLoyaltyCardSearch, clerkLoyaltyCardInsert } from '@/utils/api';
import i18n from '@/utils/i18n';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import { printer } from '@/utils/printer';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    registerForm: {
      firstName: '',
      lastName: '',
      country: 'US',
      email: '',
      password: '',
      passwordRepeat: '',
      mobilePhone: '',
      birthMonth: '',
      birthDay: '',
      birthYear: '',
      howDidYouHear: '',
      promoCode: '',
      agreeTos: false,
      countries: [],
    },
    registerStatus: {
      loading: false,
      success: false,
      error: false,
    },
    playerSearchForm: {
      clerk_search_email: '',
      clerk_search_account_name: '',
      clerk_search_first_name: '',
      clerk_search_last_name: '',
    },
    clerkPlayerSearchStatus: {
      loading: false,
      success: false,
      error: false,
    },
    clerkPlayerSearchResult: [],
    clerkLoyaltyCardSearchStatus: {
      loading: false,
      success: false,
      error: false,
    },
    clerkLoyaltyCardSearchResult: [],
    clerkLoyaltyCardInsertStatus: {
      loading: false,
      success: false,
      error: false,
    },
    newDgsPlayerId: '',
    newDgsPlayerAlias: '',
  };
};
const state = getDefaultState();

const getters = {
  getField,
  loyaltyCardsTableFields: _ => [
    {
      key: 'card_id',
      label: i18n.t('ClerkLoyalty.Card Id'),
      _searchable: true,
      _sortable: true,
      _sortDirection: 'desc',
    },
    {
      key: 'dgs_player_id',
      label: i18n.t('ClerkLoyalty.DgsPlayerId'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'account.account_name',
      label: i18n.t('ClerkLoyalty.Account'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'user_id',
      label: i18n.t('ClerkLoyalty.Clerk Id'),
      _searchable: true,
      _sortable: false,
    },
  ],
  clerkPlayerSearchTableFields: _ => [
    {
      key: 'alias',
      label: i18n.t('ClerkLoyalty.Account'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'primary_email',
      label: i18n.t('RegisterView.Email'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'first_name',
      label: i18n.t('RegisterView.FirstName'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'last_name',
      label: i18n.t('RegisterView.LastName'),
      _searchable: true,
      _sortable: false,
    },
    {
      key: 'options',
      label: i18n.t('ClerkDeposit.Options'),
      _searchable: false,
      _sortable: false,
    },
  ],
};

const mutations = {
  updateField,
  updateRegisterStatus(state, row) {
    state.registerStatus = {
      ...state.registerStatus,
      ...row,
    };
  },
  setCountries(state, arr) {
    state.registerForm.countries = arr;
  },
  updateClerkPlayerSearchStatus(state, row) {
    state.clerkPlayerSearchStatus = {
      ...state.clerkPlayerSearchStatus,
      ...row,
    };
  },
  setClerkPlayerSearchResult(state, arr) {
    state.clerkPlayerSearchResult = arr;
  },
  updateClerkLoyaltyCardSearchResult(state, row) {
    state.clerkLoyaltyCardSearchStatus = {
      ...state.clerkLoyaltyCardSearchStatus,
      ...row,
    };
  },
  setClerkLoyaltyCardSearchResult(state, arr) {
    state.clerkLoyaltyCardSearchResult = arr;
  },
  updateClerkLoyaltyCardInsertStatus(state, row) {
    state.clerkLoyaltyCardInsertStatus = {
      ...state.clerkLoyaltyCardInsertStatus,
      ...row,
    };
  },
  setNewDgsPlayerId(state, id) {
    state.newDgsPlayerId = id;
  },
  setNewDgsPlayerAlias(state, id) {
    state.newDgsPlayerAlias = id;
  },
};

const actions = {
  tryRegister(
    { commit, dispatch },
    {
      email,
      password,
      passwordRepeat,
      firstName,
      lastName,
      promoCode,
      hearAbout,
      hearAboutDetail,
      refererSignup,
      signupDeviceType,
      signupDeviceAgent,
      remoteIp,
      language,
      requestDomain,
      agreeTos,
      doNotEmail,
    },
  ) {
    if (password === '') {
      commit('updateRegisterStatus', {
        error: i18n.t('RegisterView.EmptyPassword'),
      });
      return;
    }

    if (password !== passwordRepeat) {
      commit('updateRegisterStatus', {
        error: i18n.t('RegisterView.PasswordRepeatWrong'),
      });
      return;
    }
    commit('updateRegisterStatus', {
      loading: true,
      success: false,
      error: false,
    });
    register(
      email,
      password,
      passwordRepeat,
      firstName,
      lastName,
      promoCode,
      hearAbout,
      hearAboutDetail,
      refererSignup,
      signupDeviceType,
      signupDeviceAgent,
      remoteIp,
      language,
      requestDomain,
      agreeTos,
      doNotEmail,
    ).then(r => {
      if (r.data.IsSuccess && !r.data.ExceptionMessage) {
        commit('updateRegisterStatus', {
          success: i18n.t('ClerkLoyalty.RegisterSuccess'),
        });
        commit('updateRegisterStatus', { error: false });
        commit('setNewDgsPlayerId', r.data.Data.Player.DgsPlayerId);
        commit('setNewDgsPlayerAlias', r.data.Data.Player.PlayerAccount);
      } else {
        commit('updateRegisterStatus', { success: false });
        commit('updateRegisterStatus', {
          error: i18n.t('Exceptions.' + r.data.ExceptionMessage[0]),
        });
      }
      commit('updateRegisterStatus', { loading: false });
    });
  },
  tryGetCountries({ commit, rootState }) {
    getCountries(rootState.settings.brandSettings.book_id, rootState.settings.selectedLocale.short_code).then(r => {
      if (r.data.IsSuccess) {
        commit('setCountries', r.data.Data);
      }
    });
  },
  tryClerkSearchPlayer({ commit, state }) {
    const formData = {
      account_name: state.playerSearchForm.clerk_search_account_name,
      primary_email: state.playerSearchForm.clerk_search_email,
      first_name: state.playerSearchForm.clerk_search_first_name,
      last_name: state.playerSearchForm.clerk_search_last_name,
    };
    commit('updateClerkPlayerSearchStatus', {
      loading: true,
      success: false,
      error: false,
    });
    clerkSearchPlayer(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('setClerkPlayerSearchResult', r.data.Data.data);
        commit('updateClerkPlayerSearchStatus', {
          loading: false,
          success: true,
          error: false,
        });
      } else {
        commit('updateClerkPlayerSearchStatus', {
          loading: false,
          success: false,
          error: true,
        });
      }
    });
  },
  printLoyaltyCard({ commit, dispatch, rootState }, { account, id, trigger, fullName }) {
    const formData = {
      user_id: rootState.player.clerk.user_id,
      mac_address: rootState.settings.macAddress,
      location_id: rootState.settings.terminalInfo.location_id,
      dgs_player_id: id,
      trigger: trigger,
    };

    commit('updateClerkLoyaltyCardInsertStatus', {
      loading: true,
      success: false,
      error: false,
    });
    clerkLoyaltyCardInsert(formData).then(r => {
      if (r.data.IsSuccess) {
        dispatch('tryClerkLoyaltyCardSearch');
        commit('updateClerkLoyaltyCardInsertStatus', {
          loading: false,
          success: true,
          error: false,
        });
        // TODO: PRINT CARD HERE
        // console.log("Card inserted succesfully", fullName, account, r.data.Data.data.scan_code);
        var dt = {
          fullName: fullName,
          KeyNumber: account,
          ScanCode: r.data.Data.data.scan_code,
          brandId: 14, //TODO get brandId
        };
        printer.printCard(dt);
        // TODO: AFTER PRINT RELOAD PAGE
        // location.reload()
      } else {
        commit('updateClerkLoyaltyCardInsertStatus', {
          loading: false,
          success: false,
          error: true,
        });
      }
    });
  },
  tryClerkLoyaltyCardSearch({ commit, rootState }) {
    const formData = {
      user_id: rootState.player.clerk.user_id,
      mac_address: rootState.settings.macAddress,
      limit: 100,
      from: '2011-05-28 04:56:10.483',
      to: '2031-05-28 04:56:10.483',
    };
    commit('updateClerkLoyaltyCardSearchResult', {
      loading: true,
      success: false,
      error: false,
    });
    clerkLoyaltyCardSearch(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('setClerkLoyaltyCardSearchResult', r.data.Data.data.data);
        commit('updateClerkLoyaltyCardSearchResult', {
          loading: false,
          success: true,
          error: false,
        });
      } else {
        commit('updateClerkLoyaltyCardSearchResult', {
          loading: false,
          success: false,
          error: true,
        });
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
